import React from 'react';
import { StarIcon } from 'lucide-react';
export function Reviews() {
  const reviews = [{
    name: 'Martín R.',
    text: 'Me salvó en el laburo, ahora entiendo todo lo que antes hacía a ciegas.',
    city: 'Buenos Aires'
  }, {
    name: 'Luciana G.',
    text: 'Lo mejor que compré este año. Súper claro y directo.',
    city: 'Córdoba'
  }, {
    name: 'Diego F.',
    text: 'Por fin alguien explica las cosas como son en el laboratorio real.',
    city: 'Rosario'
  }];
  return <section className="w-full px-4 py-6 bg-gray-50" data-id="element-158">
      <div className="max-w-4xl mx-auto" data-id="element-159">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-160">
          {reviews.map((review, index) => <div key={index} className="bg-white p-3 rounded-lg shadow-sm" data-id="element-161">
              <div className="flex gap-0.5 mb-1.5" data-id="element-162">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" data-id="element-163" />)}
              </div>
              <p className="text-xs text-gray-700 mb-1.5 italic leading-snug" data-id="element-164">
                "{review.text}"
              </p>
              <p className="text-[11px] font-semibold text-gray-900" data-id="element-165">
                {review.name} · {review.city}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}